"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amountToLong = amountToLong;
const AMOUNT_LONG_MULTIPLIER = 100000;
/**
 * Converts string amount to numeric representation in LONG type required
 * by BI system
 */
function amountToLong(amount) {
    if (Number.isNaN(Number(amount))) {
        return 0;
    }
    return Math.floor(Number(amount) * AMOUNT_LONG_MULTIPLIER);
}
//# sourceMappingURL=amountToLong.js.map